export enum TreeNodeType {
  COLLECTION = "collection",
  MANIFEST = "manifest",
  RANGE = "range",
}
